import React from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { MODULES } from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import { ULTRA_PLAN_ROUTES } from '../../../ultraPlanConstants';
import { getRoadmapRoute, getSubscriberRoute } from '../../../ultraPlanUtils';
import RoadmapsTable from '../components/list/RoadmapsTable';
import RoadmapDrawer from '../components/roadmap/RoadmapDrawer';
import SubscriberDrawer from '../components/subscriber/SubscriberDrawer';

const Roadmaps = () => {
  const history = useHistory();
  const location = useLocation();
  const roadmapMatch = useRouteMatch({
    path: ULTRA_PLAN_ROUTES?.ROADMAP,
    exact: true,
  });
  const subscriberMatch = useRouteMatch({
    path: ULTRA_PLAN_ROUTES?.SUBSCRIBER,
    exact: true,
  });

  const toParams = (record) => ({
    userId: record?.user?.id,
    userSubscriptionId: record?.id,
  });

  const openFromList = (pathname) =>
    history?.push({
      pathname,
      search: location?.search,
      state: { fromList: true },
    });

  const switchDrawer = (pathname) =>
    history?.replace({
      pathname,
      search: location?.search,
      state: location?.state,
    });

  const closeDrawer = () => {
    if (location?.state?.fromList) {
      history?.goBack();
      return;
    }
    history?.replace({
      pathname: ULTRA_PLAN_ROUTES?.LIST,
      search: location?.search,
    });
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.ROADMAPS}</div>
      </Portal>
      <RoadmapsTable
        onOpenRoadmap={(record) =>
          openFromList(getRoadmapRoute(toParams(record)))
        }
        onOpenSubscriber={(record) =>
          openFromList(getSubscriberRoute(toParams(record)))
        }
      />
      <SubscriberDrawer
        params={subscriberMatch?.params}
        onClose={closeDrawer}
        onOpenRoadmap={(params) => switchDrawer(getRoadmapRoute(params))}
      />
      <RoadmapDrawer
        params={roadmapMatch?.params}
        onClose={closeDrawer}
        onOpenSubscriber={(params) => switchDrawer(getSubscriberRoute(params))}
      />
    </>
  );
};

export default Roadmaps;
